import {
  CreatedApiKey,
  StoreApiKeyListResponse,
  StoreApiKeyMutationResponse,
} from '@/@types/ApiKey';
import { api } from './api';

async function list(page = 1): Promise<StoreApiKeyListResponse> {
  const response = await api.get(`/v1/api-keys?page=${page}`);
  return response.data;
}

async function create(name: string): Promise<{ message: string; data: CreatedApiKey }> {
  const response = await api.post('/v1/api-keys', { name });
  return response.data;
}

async function toggle(
  id: number,
  active: boolean
): Promise<StoreApiKeyMutationResponse> {
  const response = await api.put(`/v1/api-keys/${id}`, { active });
  return response.data;
}

async function remove(id: number): Promise<{ message: string }> {
  const response = await api.delete(`/v1/api-keys/${id}`);
  return response.data;
}

export const ApiKeysService = {
  list,
  create,
  toggle,
  remove,
};
